import React from 'react';
import { IResourceComponentsProps } from '@refinedev/core';
import { Create, useForm, useSelect } from '@refinedev/antd';
import { DatePicker, Form, Input, Select } from 'antd';
import { capitalize } from 'lodash';
import dayjs from 'dayjs';

export const FootballFestCategoryCreate: React.FC<
  IResourceComponentsProps
> = () => {
  const { formProps, saveButtonProps, form } = useForm({
    action: 'create',
    resource: 'football-fest/category',
    successNotification: (data) => {
      return {
        message: `Created league ${data?.data.id}`,
        type: 'success',
      };
    },
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical" style={{ width: '200px' }}>
        <Form.Item label="Name" name={['name']}>
          <Input />
        </Form.Item>
        <Form.Item label="Logo URL" name={['iconUrl']}>
          <Input />
        </Form.Item>
        <Form.Item label="Season" name={['season']}>
          <Input type="number" />
        </Form.Item>
        <Form.Item label="LeagueId" name={['leagueId']}>
          <Input />
        </Form.Item>
        <Form.Item label="startTime (UTC)" name={['startTime']}>
          <DatePicker showTime />
        </Form.Item>
        <Form.Item label="endTime (UTC)" name={['endTime']}>
          <DatePicker showTime />
        </Form.Item>
      </Form>
    </Create>
  );
};
